import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { SelectedSlotsState } from '../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import globalCourseStore from '../../../../../stores/global-course-store';
import globalLectureBuilderStore from '../../../../../stores/global-lecture-builder-store';
import {
  ApiErrorCodes,
  displayErrorText,
} from '../../../../../api/errors/api-error-codes';

export const updateLectureSchedulesOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  lectureId: number | undefined,
  scheduleId: number | undefined,
  selectedSlotsState: SelectedSlotsState,
  onFinished: () => any,
  professorRetroactiveWorkingHours: boolean,
) => {
  try {
    if (!programId || !courseId || !lectureId || !scheduleId) {
      toast.warn(
        'לא ניתן לאתר את מזהה הקורס ו/או התוכנית, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }
    // TODO
    const res = await appApi.updateLecturesSchedules(
      programId,
      courseId,
      lectureId,
      scheduleId,
      selectedSlotsState[0][0].startTime,
      selectedSlotsState[0][0].endTime,
      selectedSlotsState[0][0].classId,
      professorRetroactiveWorkingHours,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      onFinished();
      return;
    }

    globalCourseStore.addCourseMetadata(res.data.body.metadata);

    globalCourseStore.addCourseDetails(courseId, res.data.body.details);
    globalCourseStore.currentId = courseId;

    const currentLecture = res.data.body.details.lectures.find(
      (item) => item.id === lectureId,
    );

    //res.data.body.details.lectures
    if (currentLecture) {
      globalLectureBuilderStore.selectedLecture = currentLecture;
    }

    toast.success('הפעולה בוצעה בהצלחה');

    onFinished();
  } catch (e) {
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
